import { render, staticRenderFns } from "./MediaMessage.vue?vue&type=template&id=5f409d4d&scoped=true&"
import script from "./MediaMessage.vue?vue&type=script&lang=js&"
export * from "./MediaMessage.vue?vue&type=script&lang=js&"
import style0 from "./MediaMessage.vue?vue&type=style&index=0&id=5f409d4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f409d4d",
  null
  
)

export default component.exports